export type SystemMessage = {
  id: number|null
  trigger_id: number|null
  name: string
  type: number
  type_label: string|null
  preview: File|null
  targets: string
  target_labels: string[]
  source_key: string|null
  notification_class: string|null
  mail_class: string|null
  view_name: string|null
  subject_template: string|null
  sample_subject: string|null
  sample_body_html: string|null
  sample_render_error: string|null
  sample_rendered_at: string|null
  auto_managed: boolean
  created_at: string|null
  related: string|null
}

export class SystemMessageData implements SystemMessage {
  id = 0
  trigger_id: number | null = null
  name = ''
  type = 0
  type_label: string|null = null
  preview: File|null = null
  targets = ''
  target_labels: string[] = []
  source_key: string|null = null
  notification_class: string|null = null
  mail_class: string|null = null
  view_name: string|null = null
  subject_template: string|null = null
  sample_subject: string|null = null
  sample_body_html: string|null = null
  sample_render_error: string|null = null
  sample_rendered_at: string|null = null
  auto_managed = false
  linked: string[] = []
  created_at: string | null = null
  related: string | null = null
}

export class SystemMessageTrigger {
  id: number | null = null
  source_key: string | null = null
  name = ''
  description = ''
  constructor ({ id = null, source_key = null, name = '', description = '' } : { id?: number|null, source_key?: string|null, name?: string, description?: string } = {}) {
    this.id = id
    this.source_key = source_key
    this.name = name
    this.description = description
  }
}
